import { ExhibitionContent } from "interfaces/front/business";
import React, { FC } from "react";
import styled from "styled-components";

export type Props = { content: ExhibitionContent };
const RelatedLinkSection: FC<Props> = ({ content }) => {
  return (
    <div>
      {content.homepage_url && (
        <div style={{ margin: "15px 0" }}>
          <Text>
            公式ホームページ
            <br />
            <a href={content.homepage_url} target="_blank" rel="noreferrer">
              {content.homepage_url}
            </a>
          </Text>
        </div>
      )}
      {content.twitter_url && (
        <div>
          <IconLink href={content.twitter_url} target="_blank" rel="noreferrer">
            <img src="/img/cast_link--tw.png" alt="twitter" />
          </IconLink>
        </div>
      )}
    </div>
  );
};
export default RelatedLinkSection;

const Text = styled.span`
  font-size: 14px;
  color: white;
  line-height: 1.428em;
  text-align: left;
  display: inline-block;

  & > a {
    color: white;
    text-decoration: underline;

    &:hover {
      text-decoration: none;
    }
  }
`;
const IconLink = styled.a`
  @media screen and (max-width: 960px) {
    width: 28px;
    height: 28px;
    display: block;
  }
  @media screen and (min-width: 961px) {
    width: 38px;
    height: 38px;
    display: inline-block;
    transition: 0.4s;
    &:hover {
      opacity: 0.6;
    }
  }

  & > img {
    width: 100%;
    height: auto;
  }
`;
